import axiosBase from "@/api/axiosBase";

const state = {
    projectList: [],  //项目信息列表
    projectChangeNum: -1,
    selectProject: null,
    selectProjectChangeNum: -1,
}

const getters = {
    projectChange: state => state.projectChangeNum,
    selectProjectChange: state => state.selectProjectChangeNum
}

const actions = {
    //查询项目
    getProjects({ dispatch, commit }, data) {
        return new Promise((resolve, reject) => {
            axiosBase({
                method: 'GET',
                url: '/basedata/project'
            }).then(res => {
                if (res.data.code != 200) {
                    commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
                }
                else {
                    commit('setProjectList', res.data.data);
                }
                resolve(res)
            })
                .catch(error => {
                    commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
                    resolve({ data: { code: 500 } })
                })
        })
    },
    //新建项目
    addProject({ dispatch, commit }, data) {
        return new Promise((resolve, reject) => {
            axiosBase({
                method: 'GET',
                url: '/basedata/project/new?project_name=' + data.projectName
            }).then(res => {
                if (res.data.code != 200) {
                    commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
                }
                else {
                    commit('setUpdateProject', res.data.data);
                }
                resolve(res)
            })
                .catch(error => {
                    commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
                    resolve({ data: { code: 500 } })
                })
        })
    },
    //修改项目
    updateProject({ dispatch, commit }, data) {
        return new Promise((resolve, reject) => {
            axiosBase({
                method: 'GET',
                url: '/basedata/project/update?project_id=' + data.projectId + '&project_name=' + data.projectName
            }).then(res => {
                if (res.data.code != 200) {
                    commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
                }
                else {
                    commit('setUpdateProject', res.data.data);
                }
                resolve(res)
            })
            .catch(error => {
                commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
                resolve({ data: { code: 500 } })
            })
        })
    },
    //删除项目
    deleteProject({ dispatch, commit }, data) {
        return new Promise((resolve, reject) => {
            axiosBase({
                method: 'GET',
                url: '/basedata/project/delete/' + data.projectId
            }).then(res => {
                if (res.data.code != 200) {
                    commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
                }
                else {
                    commit('setDeleteProject', data.projectId);
                }
                resolve(res)
            })
                .catch(error => {
                    commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
                    resolve({ data: { code: 500 } })
                })
        })
    }
}

const mutations = {
    setProjectList(state, list) {
        if (list.length == 0) {
            state.projectList = [];
        }
        else {
            state.projectList = list.sort((a, b) => new Date(a.createTime) - new Date(b.createTime));
        }
        state.projectChangeNum += 1;
    },
    setUpdateProject(state, project) {
        state.projectList = state.projectList.filter(p => p.id != project.id);
        state.projectList.push(project);
        
        state.projectList.sort((a, b) => new Date(a.createTime) - new Date(b.createTime))
        state.projectChangeNum += 1;
    },
    setDeleteProject(state, projectId) {
        state.projectList = state.projectList.filter(p => p.id != projectId);
        state.projectChangeNum += 1;
    },
    // // //设置选中项目
    setSelectProject(state, _selectProject) { 
        state.selectProject = _selectProject;
        state.selectProjectChangeNum += 1;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}